module.exports = __webpack_public_path__ + "img/OBCINA MISLINJA.61364292.png";